export const socialHandles = [
  {
    icon: "https://cdn.pixabay.com/photo/2016/08/09/17/52/instagram-1581266_1280.jpg",
    site: "https://www.instagram.com/apoorv_142001/",
  },
  {
    icon: "https://1000logos.net/wp-content/uploads/2021/04/Facebook-logo.png",
    site: "https://www.facebook.com/apoorv.jain.9659/",
  },
  {
    icon: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQJlX7PTlrKYVgH-NTeYy2E-LOESO2w1v_CPA&usqp=CAU",
    site: "https://www.linkedin.com/in/apoorv-jain-87ba16190/",
  },
];

export const ProgrmmingHandles = [
  {
    icon: "https://res.cloudinary.com/practicaldev/image/fetch/s--mzwvoucO--/c_imagga_scale,f_auto,fl_progressive,h_1080,q_auto,w_1080/https://dev-to-uploads.s3.amazonaws.com/uploads/articles/cer3l19eex0wy900b101.jpg",
    site: "https://codeforces.com/profile/Greedy_Optimizzer/",
  },
  {
    icon: "https://gitgud.io/uploads/-/system/group/avatar/12294/cc.png",
    site: "https://www.codechef.com/users/jainapoorv094/",
  },
  {
    icon: "https://camo.githubusercontent.com/898f94be504f7baf1ddb0a2811152dab61cfd723e683b6947be9ffa3c879ccc4/68747470733a2f2f75706c6f61642e77696b696d656469612e6f72672f77696b6970656469612f636f6d6d6f6e732f362f36352f4861636b657252616e6b5f6c6f676f2e706e67",
    site: "https://www.hackerrank.com/certificates/51239c055863",
  },
  {
    icon: "https://pbs.twimg.com/profile_images/1414990564408262661/r6YemvF9_400x400.jpg",
    site: "https://github.com/apoorv-14200",
  },
];
